.googleMapsEmbed {
  &__container {
    padding: 15px 0;
  }

  &__map {
    cursor: pointer;
    height: 100%;
    overflow: hidden;
    padding-bottom: 75%;
    position: relative;
    width: 100%;
  }

  &__iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
